<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Movimientos Bancarios</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <router-link
                class="btn btn-sm btn-success"
                :to="{ name: 'bancos-movimiento-bancario-nuevo', params: {} }"
              >
                <i class="fa fa-plus"></i>
                Nuevo Movimiento
              </router-link>
            </div>
            <div class="row col-12 justify-content-sm-end">
              <div class="col-2">
                <input
                  @change="filterData()"
                  class="form-control form-control-sm rounded bright"
                  v-model="filter.fecha"
                  type="date"
                />
              </div>
              <div class="col-2">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                  v-on:keyup.enter="filterData()"
                />
              </div>
              <div class="col-2">
                <select
                  @change="filterData()"
                  class="form-control form-control-sm rounded"
                  v-model="filter.tipo_movimiento"
                >
                  <option value="">TIPO MOVIMIENTO</option>
                  <option value="CH">CHEQUE</option>
                  <option value="DP">DEPOSITO</option>
                  <option value="DV">DEPOSITOS VARIOS</option>
                  <option value="NC">NOTAS CREDITO</option>
                  <option value="ND">NOTA DEBITO</option>
                  <option value="RD">REDEPOSITO</option>
                  <option value="SI">SALDO INICIAL</option>
                  <option value="TF">TRANSFERENCIA</option>
                </select>
              </div>
              <TiendaSelectComponent
                class="col-sm-2"
                _class="form-control form-control-sm rounded bright"
                titulo="hide"
                style="display: block"
                :desblock="true"
                placeholder="FILTRO DE TIENDAS"
                :current="filter"
                @change="filterData()"
                @onChange="filterData()"
              />
              <div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filterActive"
                  @click="filterData()"
                >
                  <option :value="null">estado</option>
                  <option value="A">abierto</option>
                  <option value="B">cerrado</option>
                  <option value="9">anulado</option>
                </select>
              </div>
              &nbsp; &nbsp;
              <div class="input-group-append">
                <button class="btn btn-link btn-sm" @click="filterData()">
                  <i class="fa fa-search"></i>
                </button>
                <button
                  class="btn btn-link btn-sm"
                  type="button"
                  v-on:click="clearFilterData()"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Numero</th>
                <th>Fecha</th>
                <th>Cuenta Bancaria</th>
                <th>Tienda</th>
                <th class="text-left">Referencia</th>
                <th class="text-left">Descripcion</th>
                <th class="text-center">Valor</th>
                <th class="text-center">Tipo Movimiento</th>
                <th class="text-center">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="rowClick(current)"
              >
                <td class="text-center">{{ current.numero }}</td>
                <td>{{ current.fecha }}</td>
                <td>
                  {{ current.cuenta_bancaria.id }} - {{ current.cuenta_bancaria.nombre }}
                </td>
                <td>{{ current.tienda.nombre }}</td>
                <td class="text-left">{{ current.referencia }}</td>
                <td class="text-left">{{ current.descripcion }}</td>
                <td style="width: 250px" class="text-center">
                  <span v-if="current.cargo != 0" class="badge badge-success"
                    >+ Q{{ current.cargo }}</span
                  > &nbsp;
                  <span v-if="current.abono != 0" class="badge badge-danger"
                    >- Q{{ current.abono }}</span
                  >
                </td>
                <td class="text-center">{{ current.tipo_movimiento }}</td>
                <td class="text-center" style="width: 100px">
                  {{ current.estado_str }}
                </td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <br />
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="filterData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import MovimientoBancarioService from "@/services/bancos/MovimientoBancarioService";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    PaginationComponent,
    UsuariosSelectComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      current: {
        estado: "A",
      },
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      data: [],
      filterActive: null,
      filter: {
        numero: "",
        fecha: "",
        tienda: "",
        usuario: "",
        cuenta_bancaria: "",
        tipo_movimiento: "",
        conciliado: "",
      },
    };
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "bancos-movimiento-bancario-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "bancos-movimiento-bancario-editar",
          params: { id: current.id },
        });
      }
    },
    filterData(page) {
      let usuario = "";
      let fecha = "";
      if (page) {
        this.currentPage = page;
      }

      if (this.filter.usuario) {
        usuario = this.filter.usuario.id;
      }
      if (this.filter.fecha) {
        fecha = moment(this.filter.fecha).format("DD/MM/YYYY");
      }
      this.refreshData({
        fecha: fecha,
        tienda: this.filter.tienda,
        tipo_movimiento: this.filter.tipo_movimiento,
        usuario: usuario,
        cuenta_bancaria: this.filter.cuenta_bancaria,
        tipo_movimiento: this.filter.tipo_movimiento,
        conciliado: this.filter.conciliado,
        estado: this.filterActive,
        page: this.currentPage,
        "filter[search]": this.searchtext,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filter.tienda = "";
      this.currentPage = 1;
      this.filter.usuario = "";
      this.filter.cuenta_bancaria = "";
      this.filter.tipo_movimiento = "";
      this.filter.conciliado = "";
      this.filter.estado = null;
      this.searchtext = "";
      this.filterActive = null;
      this.refreshData();
    },
    hide: function () {
      this.$data.destroy();
    },
    refreshData(params) {
      let self = this;
      MovimientoBancarioService.fetch(params)
        .then((res) => {
          self.data = res.data;
        })
        .catch((error) => {
          self.data = "";
        });
    },
    showModalEdit() {},
  },
};
</script>
